import { render } from "./form-basic-inputs.vue?vue&type=template&id=f841fe0c"
import script from "./form-basic-inputs.vue?vue&type=script&lang=js"
export * from "./form-basic-inputs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__